/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeBulkDeleteDocumentsRequest, type BulkDeleteDocumentsRequest, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/documents/bulk-delete
 */
export interface BulkDeleteRequestBuilder extends BaseRequestBuilder<BulkDeleteRequestBuilder> {
    /**
     * Deletes up to 100 documents in one call, permanently and with no recycle bin. Send at least one id and no more than 100; a longer list is refused rather than truncated, so split larger deletions across calls. Every id must exist in this organization: the whole list is checked before anything is deleted, so a single unknown id refuses the call with the batch left intact — nothing is deleted and the request is safe to correct and re-send. Nothing is returned on success.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: BulkDeleteDocumentsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Deletes up to 100 documents in one call, permanently and with no recycle bin. Send at least one id and no more than 100; a longer list is refused rather than truncated, so split larger deletions across calls. Every id must exist in this organization: the whole list is checked before anything is deleted, so a single unknown id refuses the call with the batch left intact — nothing is deleted and the request is safe to correct and re-send. Nothing is returned on success.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: BulkDeleteDocumentsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BulkDeleteRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/documents/bulk-delete";
/**
 * Metadata for all the requests in the request builder.
 */
export const BulkDeleteRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BulkDeleteRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBulkDeleteDocumentsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
